import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { StyledStatusIndicatorWrapper } from './EditSensor.styles';

interface SpinnerStatusIndicatorProps {
	visible: boolean;
	text: string;
}

export const SpinnerStatusIndicator: React.FC<SpinnerStatusIndicatorProps> = (
	props: SpinnerStatusIndicatorProps,
) => {
	const { visible, text } = props;
	return visible ? (
		<StyledStatusIndicatorWrapper>
			<CircularProgress size={18} />
			<Typography>{text}</Typography>
		</StyledStatusIndicatorWrapper>
	) : (
		<></>
	);
};
